module.exports = [
    "$routeProvider", ($routeProvider) => {
        $routeProvider
            .when('/', {
                template: ''
            })
            .when('/c/:id', {
                templateUrl   : 'theme/grassroots/detail',
                controller    : 'CampaignController',
                controllerAs  : 'detail',
                resolve       : {
                    _CurrentCampaign: [
                        "$route",
                        "$location",
                        "CurrentCampaign",
                        ($route, $location, CurrentCampaign) => CurrentCampaign
                            .set($route.current.params.id)
                            .then(null, () => $location.path('/'))
                    ]
                },
                reloadOnSearch: false
            })
            .otherwise({
                redirectTo: '/'
            });
    }
];
